/*eslint no-unreachable: "off"*/
/*eslint no-useless-concat: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint no-unused-vars: "off"*/
export function insertComma(n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
}

function chartColor(displayName) {
  if (displayName.indexOf('VHF') !== -1) return "#fabc05";
  else if (displayName.indexOf('UHF') !== -1) return "#5587a2";
  else if (displayName.indexOf('HF') !== -1) return "#4452a8";
  else if (displayName.indexOf('기타') !== -1) return "#69cabc";
  else return "#cccccc";
}

/**
 title: "지역별 아마추어무선국 수",
 xtitle: "무선국 수",
 ytitle: "지역명",
 chartType: "Multi Series Stacked Bar",
 layOutStyle: "Detail",
 masterName: "무선국 수",
 valueFixed: 0,
 */
export function layoutForChart1(
  chartLayoutProps, {
    searchYear,
    prm_check, prm_check_label,
  }
) {
  let layOutData;
  let dataTipJsFunctionData;
  if (chartLayoutProps.valueFixed > 0) {
    if (chartLayoutProps.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_stacked_bar"';
    }
  } else {
    if (chartLayoutProps.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_stacked_bar"';
    }
  }


  layOutData =
    '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
    + '<Caption fontSize="19" text="' + chartLayoutProps.title + '  "/>'
    //+'<Caption fontSize="19" text="'+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear + '년)"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Bar3DChart showDataTips="true"' + dataTipJsFunctionData + '>'
    + '<horizontalAxis>'
    + '<LinearAxis formatter="{numfmt}" id="hAxis" title="' + chartLayoutProps.xtitle + '" labelJsFunction="labelFuncNum"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<CategoryAxis id="vAxis" categoryField="GUBUN_NM" title="' + chartLayoutProps.ytitle + '" labelJsFunction="labelFunc"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="false" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';
  layOutData +=
    '<Bar3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
    + '<series>';

  for (let j = 0; j < prm_check.length; j++) {

    layOutData +=
      '<Bar3DSeries labelPosition="inside" xField="DATA_' + prm_check[j] + '_CNT" displayName="' + prm_check_label[j] + '" styleName="seriesLabel" showValueLabels="[]">'
      + '<fill>'
      + '<SolidColor color="' + chartColor(prm_check_label[j]) + '"/>'
      + '</fill>'
      + '<showDataEffect>'
      + '<SeriesInterpolate/>'
      + '</showDataEffect>'
      + '</Bar3DSeries>';

  }

  layOutData +=
    '</series>'
    + '</Bar3DSet>';

  layOutData +=
    '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="vertical"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    /* CrossRangeZoomer 속성 설명
* zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
* horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
* verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
* enableZooming : zoom 기능 사용 여부를 나타냅니다.
* enableCrossHair : 십자가 표시 여부를 나타냅니다.
* useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
* horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
*/
    + '</annotationElements>'
    + '</Bar3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layOutData;
}

/**
 title: "년도별 아마추어무선국 수",
 xtitle: "년도",
 ytitle: "무선국 수",
 chartType: "Multi Series Stacked",
 layOutStyle: "Master",
 masterName: "2",
 valueFixed: 0,
 */
export function layoutForChart2(chartLayoutProps, chartData, {searchYear, prm_check, prm_check_label}) {
  let layOutData;


  let subTitle;
  if (chartData.length > 0) {
    let minYear = "9999";
    let maxYear = "0";
    for (let t = 0; t < chartData.length; t++) {

      let item = chartData[t];
      if (Number(minYear) > Number(item.YEAR)) minYear = item.YEAR;
      if (Number(maxYear) < Number(item.YEAR)) maxYear = item.YEAR;
    }

    subTitle = minYear + " ~ " + maxYear + "년";
  } else {
    subTitle = searchYear + "년";
  }

  layOutData =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="19" text="' + chartLayoutProps.title + '  " />'
    //+'<Caption fontSize="19" text="'+chartBaseData["chart"+i].title+'  &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt;" />'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + subTitle + ')"/>'
    + '<Legend useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<Column3DChart showDataTips="true" dataTipJsFunction="dataTipFunc">'
    /*
  Bar3D차트 생성시엔 Bar3DChart를 정의합니다
  showDataTips : 데이터에 마우스를 가져갔을 때 나오는 Tip을 보이기/안보이기 속성입니다.
     */
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis" labelJsFunction="labelFuncNum" title="' + chartLayoutProps.ytitle + '"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<horizontalAxis>'
    /* Bar3D차트는 y축에서 데이터 시리즈가 나오는 형태이어서 verticalAxis축을 참고합니다 */
    + '<CategoryAxis id="hAxis" categoryField="YEAR" title="' + chartLayoutProps.xtitle + '" labelJsFunction="labelFunc"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<series>'
    + '<Column3DSet type="stacked" showTotalLabel="false" totalLabelJsFunction="totalFunc" labelYOffset="-7">'
    + '<series>';

  for (let j = 0; j < prm_check.length; j++) {

    layOutData += '<Column3DSeries id="' + prm_check[j] + '" labelPosition="none" yField="DATA_' + prm_check[j] + '_CNT" displayName="' + prm_check_label[j] + '" lineToEachItems="true" color="#666666">'
      + '<fill>'
      + '<SolidColor color="' + chartColor(prm_check_label[j]) + '"/>'
      + '</fill>'
      /* lineToEachItems : True로 설정 하면 Series간에 선을 이어준다 */
      + '<showDataEffect>'
      + '<SeriesInterpolate/>'
      + '</showDataEffect>'
      + '</Column3DSeries>';
  }

  layOutData += '</series>'
    + '</Column3DSet>'
    + '</series>'
    + '</Column3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';
  return layOutData;
}


window.labelFunc = function (index, value) {
  return '<font size="15">' + value + '</font>';
  return "";
};
window.labelFunc2 = function (index, value) {
  return '<font size="13">' + value + '</font>';
  return "";
};
window.labelFuncNum = function (index, value) {
  return '<font size="15">' + window.insertComma(value) + '</font>';
  return "";
};

window.totalFunc = function (index, data, value) {
  if (index === 3)
    return window.insertComma(value);
  return "";
};

//숫자에 천단위 콤마 찍어 반환하는 함수.
window.insertComma = function (n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
};
window.dataTipFunc = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style=\"font-size:15px;\"><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + insertComma(Number(values[1])) + "</font>";
};

window.dataTipFunc0 = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b> : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2 = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><font style='font-size:15px;'><b>" + values[0] + "</b> : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";
};

window.dataTipFunc0_stacked = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2_stacked = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";

};

window.dataTipFunc2_Pie = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'>" + data.DATA_FIELD + " : <b>" + data.DATA_SUM_str
    + ", " + window.insertComma(Number(values[1]).toFixed(2)) + "%</b>" + "</font>";
};

window.dataTipFunc0_stacked_bar = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style=\"font-size:15px;\"><b>" + values[1] + "</b>"
    + "<br/>" + seriesName + " : " + insertComma(Number(values[0])) + "</font>";

};

window.dataTipFunc2_stacked_bar = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<b>" + values[1] + "</b>"
    + "<br/>" + seriesName + " : " + insertComma(Number(values[0]).toFixed(2)) + " %";

};